import { gql, TypedDocumentNode } from '@apollo/client';

import {
  ColumnsData,
  DashboardCard,
  DashboardCardCreateInput,
  DashboardCardDeleteInput,
  DashboardCardsConnection,
  DashboardCardsConnectionInput,
  DashboardCardsLayoutConnection,
  DashboardCardsLayoutUpdateInput,
  DashboardCardUpdateInput,
  RecentlyUpdatedItem,
} from '@atom/types/dashboard';

export const BASE_DASHBOARD_CARD_FRAGMENT = gql`
  fragment BaseDashboardCard on DashboardCard {
    id
    userId
    type
    title
    size
    embedLink
  }
`;

export const GET_DASHBOARD_CARDS: TypedDocumentNode<
  { dashboardCards: DashboardCardsConnection },
  { input: DashboardCardsConnectionInput }
> = gql`
  query dashboardCards($input: DashboardCardsConnectionInput!) {
    dashboardCards(input: $input) {
      ...BaseDashboardCard
    }
  }
  ${BASE_DASHBOARD_CARD_FRAGMENT}
`;

export const GET_DASHBOARD_CARDS_LAYOUT: TypedDocumentNode<
  { dashboardCardsLayout: DashboardCardsLayoutConnection },
  { input: DashboardCardsConnectionInput }
> = gql`
  query dashboardCardsLayout($input: DashboardCardsConnectionInput!) {
    dashboardCardsLayout(input: $input) {
      id
      columns
    }
  }
`;

export const DASHBOARD_CARDS_LAYOUT_UPDATE: TypedDocumentNode<
  { dashboardCardsLayoutUpdate: { columns: ColumnsData } },
  { input: DashboardCardsLayoutUpdateInput }
> = gql`
  mutation dashboardCardsLayoutUpdate(
    $input: DashboardCardsLayoutUpdateInput!
  ) {
    dashboardCardsLayoutUpdate(input: $input) {
      columns
    }
  }
`;

export const GET_RECENTLY_UPDATED_ITEMS: TypedDocumentNode<
  { recentlyUpdatedItems: RecentlyUpdatedItem[] },
  { input: DashboardCardsConnectionInput }
> = gql`
  query recentlyUpdatedItems($input: DashboardCardsConnectionInput!) {
    recentlyUpdatedItems(input: $input) {
      workOrderId
      workOrderName
      workTemplateName
      statusId
      assetId
      assetName
      schemaName
      isMaterial
      locationType
      markerId
      userId
      firstName
      lastName
      email
      photoUrl
      itemType
      updatedDate
      colorId
    }
  }
`;

export const CREATE_DASHBOARD_CARD: TypedDocumentNode<
  { dashboardCardCreate: DashboardCard },
  { input: DashboardCardCreateInput }
> = gql`
  mutation dashboardCardCreate($input: DashboardCardCreateInput!) {
    dashboardCardCreate(input: $input) {
      ...BaseDashboardCard
    }
  }
  ${BASE_DASHBOARD_CARD_FRAGMENT}
`;

export const DELETE_DASHBOARD_CARD: TypedDocumentNode<
  { dashboardCardDelete: boolean },
  { input: DashboardCardDeleteInput }
> = gql`
  mutation dashboardCardDelete($input: DashboardCardDeleteInput!) {
    dashboardCardDelete(input: $input)
  }
`;

export const UPDATE_DASHBOARD_CARD: TypedDocumentNode<
  { dashboardCardUpdate: DashboardCard },
  { input: DashboardCardUpdateInput }
> = gql`
  mutation dashboardCardUpdate($input: DashboardCardUpdateInput!) {
    dashboardCardUpdate(input: $input) {
      ...BaseDashboardCard
    }
  }
  ${BASE_DASHBOARD_CARD_FRAGMENT}
`;
